import { ConcreteEncodable } from "./ConcreteEncodable";

import { SystemMonitorEventImplEncoder } from "../../encoder/SystemMonitorEventImplEncoder";

import * as CubiqTS from "../../index";
import { SystemMonitorEvent } from "../SystemMonitorEvent";

export class SystemMonitorEventImpl extends ConcreteEncodable implements SystemMonitorEvent {
  public static enType: string = "com.bcdfx.sysmon.impl.SystemMonitorEventImpl";

  /*FID=1*/
  public dataMap: Map<string, string> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SystemMonitorEventImplEncoder.Instance;
    this.setEncodableType(SystemMonitorEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SystemMonitorEventImpl[" + "dataMap=" + this.dataMap + "messageId=" + this.messageId + "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
